var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 67,
    viewBox: "0 0 61 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1895_735)",
    filter: "url(#filter0_d_1895_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8251 58.6921C24.3798 55.9572 18.9072 51.6273 15.1092 46.3139C14.2528 45.0827 16.5497 43.934 17.6531 44.6773C20.6622 46.6678 23.9187 48.3888 27.3729 49.9189C20.3352 35.6091 23.3064 18.5287 31.918 2.21252C32.9887 0.238028 36.3124 0.237844 35.6413 2.01175C30.2781 16.5106 29.6772 31.2671 35.4052 44.1029C36.7972 41.1729 38.4192 38.0221 41.8656 35.9506C43.3787 35.0412 45.249 35.0352 45.6096 36.0963C46.509 38.6538 44.3357 41.7471 42.9952 44.8354C41.3743 48.6352 39.6009 52.4918 38.1794 56.3285C37.5632 58.073 34.1106 59.527 31.8244 58.6926L31.8251 58.6921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4626 21.5752C21.3669 26.7696 21.1416 27.3586 20.8959 31.649C20.6377 36.1645 20.4732 34.6997 20.9082 36.6497C20.9817 36.9775 21.404 36.9715 21.5332 36.88C22.233 36.3822 22.174 32.5221 23.2107 22.2356C23.2778 21.5673 23.1043 21.1034 22.4629 21.5757L22.4626 21.5752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4664 44.0465C43.0152 46.7172 42.8102 47.0086 41.8741 49.2904C40.889 51.6923 41.1103 50.8841 40.9026 51.9845C40.8679 52.1695 41.0372 52.2149 41.1064 52.1808C41.4828 51.9931 42.213 49.9081 44.6346 44.4885C44.7918 44.1366 44.8132 43.8663 44.4656 44.0469L44.4664 44.0465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1895_735",
    x: -4,
    y: 0,
    width: 68.5225,
    height: 72.3916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1895_735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1895_735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1895_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.0202,
    height: 40.3853,
    fill: "white",
    transform: "matrix(-0.501359 -0.86524 -0.86524 0.501359 60.5225 44.1445)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic-arrow-down.4544b8ec6618e85ec4478abf18d97c06.svg";
export { ForwardRef as ReactComponent };